var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    stroke: "#57454A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0007 31.79C26.512 31.79 31.7905 26.5115 31.7905 20.0002C31.7905 13.4889 26.512 8.21045 20.0007 8.21045C13.4894 8.21045 8.21094 13.4889 8.21094 20.0002C8.21094 26.5115 13.4894 31.79 20.0007 31.79Z",
    strokeWidth: 2.76
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 38.5C30.5279 38.5 38.5 30.5279 38.5 20C38.5 9.47207 30.5279 1.5 20 1.5C9.47207 1.5 1.5 9.47207 1.5 20C1.5 30.5279 9.47207 38.5 20 38.5Z",
    strokeWidth: 2.76
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.9995 24.517C22.4942 24.517 24.5165 22.4947 24.5165 20C24.5165 17.5053 22.4942 15.4829 19.9995 15.4829C17.5048 15.4829 15.4824 17.5053 15.4824 20C15.4824 22.4947 17.5048 24.517 19.9995 24.517Z",
    strokeWidth: 2.76
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWood);
export default __webpack_public_path__ + "static/media/wood.571e78b54f9a19e27e728e25e0f54a20.svg";
export { ForwardRef as ReactComponent };